import(/* webpackMode: "eager", webpackExports: ["HomeView"] */ "/app/src/components/content/HomeView.tsx");
